<template>
  <div class="laudos-tab-container">
    <!-- Entry Laudo -->
    <section class="laudo-section" data-testid="laudo-entrada-section">
      <header class="laudo-section-header">
        <h3 class="laudo-section-title">{{ t('Laudo de Entrada') }}</h3>
        <Button
          v-if="canConfirmEntry"
          :label="t('Confirmar Laudo de Entrada')"
          icon="pi pi-check"
          size="small"
          severity="success"
          raised
          :loading="isConfirmingEntry"
          data-testid="confirm-entry-laudo-btn"
          @click="handleConfirmEntry"
        />
      </header>
      <SOEntryReportPage
        ref="entryReportRef"
        :order-item-id="itemId"
        embedded
      />
    </section>

    <!-- Exit Laudo -->
    <section class="laudo-section" data-testid="laudo-saida-section">
      <header class="laudo-section-header">
        <h3 class="laudo-section-title">{{ t('Laudo de Saída') }}</h3>
        <Button
          v-if="canConfirmExit"
          :label="t('Confirmar Laudo de Saída')"
          icon="pi pi-check"
          size="small"
          severity="success"
          raised
          :loading="isSavingExit"
          data-testid="confirm-exit-laudo-btn"
          @click="handleConfirmExit"
        />
      </header>
      <PDVExitReportPage
        ref="exitReportRef"
        :order-item-id="itemId"
        embedded
      />
    </section>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const props = defineProps<{
  itemId: number;
}>();

const entryReportRef = ref<{ handleConfirm?: () => Promise<void>; canConfirm?: boolean; isConfirming?: boolean } | null>(null);
const exitReportRef = ref<{ handleConfirm?: () => Promise<void>; canConfirm?: boolean; isSaving?: boolean } | null>(null);

const canConfirmEntry = computed(() => entryReportRef.value?.canConfirm ?? false);
const canConfirmExit = computed(() => exitReportRef.value?.canConfirm ?? false);
const isConfirmingEntry = computed(() => entryReportRef.value?.isConfirming ?? false);
const isSavingExit = computed(() => exitReportRef.value?.isSaving ?? false);

function loadData() {
  // Embedded pages self-load on mount
}

async function handleConfirmEntry() {
  if (entryReportRef.value?.handleConfirm) {
    await entryReportRef.value.handleConfirm();
  }
}

async function handleConfirmExit() {
  if (exitReportRef.value?.handleConfirm) {
    await exitReportRef.value.handleConfirm();
  }
}

defineExpose({ loadData });
</script>

<style scoped>
.laudos-tab-container {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.laudo-section {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.laudo-section + .laudo-section {
  padding-top: 1.5rem;
  border-top: 1px solid var(--p-content-border-color);
}

.laudo-section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}

.laudo-section-title {

  font-size: 1rem;
  font-weight: 600;
  margin: 0;
  color: var(--p-text-color);
}
</style>
